module.exports = __webpack_public_path__ + "static/media/Dollar.4d5ee6cf.svg";